var React = require('react');

function LineCenter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m254,1l0,58.5l-253,0l0,300.5","fill":"none","stroke":"#dae0e5","strokeWidth":"2"}));
}

LineCenter.defaultProps = {"height":"382","width":"255","viewBox":"0 0 255 382"};

module.exports = LineCenter;

LineCenter.default = LineCenter;
